// ABOUTME: Detects the one-time marker the legacy my.stekz.com redirect appends
// ABOUTME: Must be imported before the router's first navigation resolves the query string
const REBRAND_QUERY_PARAM = "rebrand";

const params = new URLSearchParams(window.location.search);

export const arrivedViaLegacyRedirect = params.has(REBRAND_QUERY_PARAM);

if (arrivedViaLegacyRedirect) {
    // Strip the marker so it never ends up baked into the router's
    // requiresAuth `returnTo` payload or lingering in the address bar.
    params.delete(REBRAND_QUERY_PARAM);
    const query = params.toString();
    const cleanUrl =
        window.location.pathname +
        (query ? `?${query}` : "") +
        window.location.hash;
    window.history.replaceState(window.history.state, "", cleanUrl);
}
